// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleSuggestList_container__rXahT","otherList":"ArticleSuggestList_otherList__25sat","button":"ArticleSuggestList_button__3qn19"};